import React, { useCallback, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { USER_ROLES } from "../constants/appConstants";
import { getUserRole } from "../services/userRoleService";

export default function SuperAdminRoute({ children }) {
  const { user, authLoading } = useAuth();
  const [checkingRole, setCheckingRole] = useState(true);
  const [role, setRole] = useState(null);

  const loadRole = useCallback(async () => {
    if (!user) {
      setRole(null);
      setCheckingRole(false);
      return;
    }
    setCheckingRole(true);
    try {
      const r = await getUserRole(user.uid);
      setRole(r);
    } finally {
      setCheckingRole(false);
    }
  }, [user]);

  useEffect(() => {
    loadRole();
  }, [loadRole]);

  if (authLoading || checkingRole) {
    return <div className="p-6">Checking super admin access...</div>;
  }

  if (!user) return <Navigate to="/login" replace />;

  if (role === null) {
    return (
      <div className="p-6 grid gap-3 max-w-md">
        <p className="text-sm text-muted-foreground">Could not verify your role. Please retry.</p>
        <button
          type="button"
          className="inline-flex h-10 items-center justify-center rounded-full border border-border px-4 text-sm"
          onClick={loadRole}
        >
          Retry
        </button>
      </div>
    );
  }

  if (role === USER_ROLES.SUPER_ADMIN) return children;
  if (role === USER_ROLES.ADMIN) return <Navigate to="/admin" replace />;
  return <Navigate to="/dashboard" replace />;
}
